import { selectDictRegionModel } from '@src/modules/dictionaries/store'
import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class MoRegionColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.MO_REGION


  constructor (store, settings) {
    const column = {
      header: {
        title: 'Субъект РФ забора крови',
        component: Combobox,
        props: {
          allowClear: true,
          mode: 'multiple',
          options: selectDictRegionModel(store.getState()).payload.map(mo => ({
            label: mo.name,
            value: mo.item_code,
            title: mo.name,
          })),
        },
        defaultValue: [],
      },
      width: 300,
      dataIndex: 'region_mo_name',
      dataRender: region_mo_name => region_mo_name ? region_mo_name : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestArgs = []

    if (filters?.region_mo_code && filters?.region_mo_code.length) {
      requestArgs = [{ field: 'region_mo_code', value: filters.region_mo_code, operator: '=', invalid: false, cast: 'right-any' }]
    }

    if (nullSearches[this.type]) {
      requestArgs = [{ field: this.type, operator: '=', value: null, invalid: false }]
    }

    return {
      control: {
        filters: requestArgs,
      },
    }
  }
}
